import React from 'react';
import { DashboardWidgetComponent } from '../../interfaces/DashboardWidgetComponent';
import { ViewDataTable } from '../../../shared/entities/view/components/view/interfaces/api/ViewDataTable';
import DashboardTable from './shared/DashboardTable';

const DashboardIPOPollWidget: DashboardWidgetComponent<ViewDataTable> = props => {
  return <DashboardTable dataTable={props.data} pinTickerColumn />;
};

export default DashboardIPOPollWidget;
